import * as React from "react";
function SvgOrigin(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={9.83}
        cy={23}
        r={8}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M11.83 3.17L17.71 1l2.12 6M17.71 1l-3.88 8M24.43 10l5.74 2.51-2.63 5.8M30.17 12.51l-8.34 3.08"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgOrigin);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
